import { useTranslation } from 'react-i18next';

import { useScheduledAssignments } from 'entities/assignments';
import { useAllClassesData, useClasses } from 'entities/classes';
import { useAssignmentsQueryInvalidation } from 'features/assignment-panel';
import { useAssets } from 'shared/api/retail';
import { useAdminPortalEntitlement } from 'shared/api/onboarding';
import { Spinner } from 'shared/ui/spinner';

import { getQuickLinksItemsData } from '../constants';

import { QuickLinksItem } from './quick-links-item';
import styles from './styles.module.scss';

export const QuickLinks = () => {
  const { t } = useTranslation();

  const { userAssets, isLoading: isUserAssetsLoading } = useAssets();

  const { allClassesKeys } = useAllClassesData();
  const { classes } = useClasses();

  const {
    scheduledAssignments,
    refetch: refetchScheduledAssignments,
    isLoading: isScheduledAssignmentsLoading,
  } = useScheduledAssignments({
    selectedClass: allClassesKeys,
    offset: 0,
    limit: 2,
  });

  useAssignmentsQueryInvalidation(refetchScheduledAssignments);

  const {
    isEntitledToAdminPortal,
    orgs,
    isLoading: isUserOrgsLoading,
  } = useAdminPortalEntitlement();

  const isClassesLoading =
    classes === null || (!!classes.length && !allClassesKeys.length);

  const isLoading =
    isUserAssetsLoading ||
    isClassesLoading ||
    isScheduledAssignmentsLoading ||
    isUserOrgsLoading;

  return (
    <div className={styles.quickLinksWrapper} id="quick_links_section">
      <div className={styles.header}>
        <h2 className={styles.title}>{t('Quick Links')}</h2>
      </div>
      {isLoading ? (
        <div className={styles.spinnerWrapper}>
          <Spinner isDark testId="quick-links-spinner" />
        </div>
      ) : (
        <ul className={styles.quickLinksList}>
          {getQuickLinksItemsData(t).map(
            ({
              id,
              LinkIcon,
              linkName,
              getLinkHref,
              checkDisplayEntitlements,
              checkDisplayByOnboardingData,
              checkDisplayByRole,
            }) => {
              let isItemVisible = true;

              // Check display entitlements if the function is provided
              if (checkDisplayEntitlements) {
                isItemVisible = checkDisplayEntitlements({
                  userAssets,
                  scheduledAssignments,
                  isEntitledToAdminPortal,
                });
              }

              // Check display by onboarding data if function is provided
              if (isItemVisible && checkDisplayByOnboardingData) {
                isItemVisible = checkDisplayByOnboardingData(orgs);
              }

              // Check display by role if function is provided
              if (isItemVisible && checkDisplayByRole) {
                isItemVisible = checkDisplayByRole();
              }

              if (!isItemVisible) return null;

              return (
                <QuickLinksItem
                  key={id}
                  linkHref={getLinkHref()}
                  linkName={linkName}
                >
                  <LinkIcon />
                </QuickLinksItem>
              );
            },
          )}
        </ul>
      )}
    </div>
  );
};
